import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        {...rest}
        className={cn(
          'block w-full min-h-tap rounded-lg border border-stone-300 bg-white px-3 py-2.5 text-base shadow-sm',
          'placeholder:text-stone-400',
          'focus:border-brand-500 focus:ring-brand-500',
          'dark:bg-stone-900 dark:border-stone-700 dark:text-stone-100 dark:placeholder:text-stone-500',
          className,
        )}
      />
    );
  },
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        {...rest}
        className={cn(
          'block w-full min-h-[6rem] rounded-lg border border-stone-300 bg-white px-3 py-2.5 text-base shadow-sm',
          'placeholder:text-stone-400',
          'focus:border-brand-500 focus:ring-brand-500',
          'dark:bg-stone-900 dark:border-stone-700 dark:text-stone-100 dark:placeholder:text-stone-500',
          className,
        )}
      />
    );
  },
);

export function Label({ children, htmlFor }: { children: React.ReactNode; htmlFor?: string }) {
  return (
    <label
      htmlFor={htmlFor}
      className="block text-sm font-medium text-stone-700 dark:text-stone-300 mb-1.5"
    >
      {children}
    </label>
  );
}
